import raw from "@/data/generated-blog-posts.json";

export interface AnswerSection {
  heading: string;
  paragraphs: string[];
  bullets?: string[];
}

export interface AnswerPost {
  slug: string;
  tradeSlug: string;
  qSlug: string;
  title: string;
  description: string;
  keyword: string;
  readMinutes: number;
  excerpt: string;
  tldr: string;
  sections: AnswerSection[];
}

const RAW = raw as Record<string, AnswerPost>;

export const ANSWER_POSTS: AnswerPost[] = Object.values(RAW).sort((a, b) =>
  a.slug.localeCompare(b.slug),
);

export function findAnswerPost(slug: string): AnswerPost | undefined {
  return RAW[slug];
}

export const ANSWER_TRADE_LABEL: Record<string, string> = {
  plumber: "Plumbers",
  electrician: "Electricians",
  hvac: "HVAC",
  roofer: "Roofers",
  painter: "Painters",
  landscaper: "Landscapers",
  "general-contractor": "General Contractors",
  remodeler: "Remodelers",
  handyman: "Handymen",
  "pest-control": "Pest Control",
  "garage-door": "Garage Door Companies",
  "window-installer": "Window Installers",
  "siding-contractor": "Siding Contractors",
  "deck-builder": "Deck Builders",
  "fence-installer": "Fence Installers",
  "concrete-contractor": "Concrete Contractors",
  "drywall-contractor": "Drywall Contractors",
  "insulation-contractor": "Insulation Contractors",
  "flooring-contractor": "Flooring Contractors",
  "chimney-sweep": "Chimney Sweeps",
  "gutter-installer": "Gutter Installers",
  "tree-service": "Tree Services",
  "pool-service": "Pool Services",
  "solar-installer": "Solar Installers",
  locksmith: "Locksmiths",
};

export function answerTradeLabel(tradeSlug: string): string {
  return ANSWER_TRADE_LABEL[tradeSlug] ?? tradeSlug;
}

export function answersByTrade(): Record<string, AnswerPost[]> {
  const out: Record<string, AnswerPost[]> = {};
  for (const p of ANSWER_POSTS) {
    (out[p.tradeSlug] ||= []).push(p);
  }
  return out;
}